import { render, staticRenderFns } from "./PeopleSwiperEmpty.vue?vue&type=template&id=1147d9c2"
import script from "./PeopleSwiperEmpty.vue?vue&type=script&lang=js"
export * from "./PeopleSwiperEmpty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports